import React, { useEffect, useState } from "react";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
import API from "../../services/api";
import { formatDate } from "../../utils/dateFormat";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";

function AssignHistory(props) {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);

  const fetchHistory = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/birdview/getBrandAssignHistory",
        method: "POST",
        responseType: "json",
        data: { brand_id: props.brand.id },
      });
      if (res.code === 200) {
        setData(res.data || []);
      }
    } catch (error) {
      console.error("Error fetching brand assign history:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.brand.id]);

  return (
    <SlDrawer
      open={props.show}
      placement="end"
      label="Assign / Unassign History"
      onSlRequestClose={(event) => {
        if (event.detail.source === "overlay") event.preventDefault();
      }}
      onSlAfterHide={() => props.setShow(false)}
      style={{ "--size": `${window.innerWidth <= 767 ? "100%" : "38vw"}` }}
    >
      <div className="mb-3 rounded-lg border border-slate-200 bg-slate-50 p-3">
        <div className="text-xs uppercase tracking-wide text-slate-400">Brand</div>
        <div className="text-base font-semibold capitalize text-slate-800">
          {props.brand.name} <span className="font-normal text-slate-400">#{props.brand.id}</span>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Sales Id</th>
              <th>Sales Person</th>
              <th>Status</th>
              <th>Assigned Date</th>
              <th>Unassigned Date</th>
              <th>Assigned By</th>
              <th>Unassigned By</th>
            </tr>
          </thead>
          {loader ? (
            <TableLoader colspan="7" />
          ) : data?.length ? (
            <tbody>
              {data.map((row) => (
                <tr key={row.id}>
                  <td>{row.sales_person_id ?? "—"}</td>
                  <td>{row.sales_person_name || "—"}</td>
                  <td>
                    <span
                      className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${
                        row.status === 1 ? "bg-green-50 text-green-700" : "bg-slate-100 text-slate-500"
                      }`}
                    >
                      {row.status === 1 ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td>{row.assigned_date ? formatDate(row.assigned_date) : "—"}</td>
                  <td>{row.unassigned_date ? formatDate(row.unassigned_date) : "—"}</td>
                  <td>{row.assigned_by_name || "—"}</td>
                  <td>{row.unassigned_by_name || "—"}</td>
                </tr>
              ))}
            </tbody>
          ) : (
            <NoDataFound colspan="7" />
          )}
        </table>
      </div>
    </SlDrawer>
  );
}

export default AssignHistory;
